import { useEffect, useMemo, useState } from 'react'
import { Loader2 } from 'lucide-react'
import VerbasTable from '../previdenciario/verbas'
import DetalhesDeCredito from '../previdenciario/detalhes-de-credito'
import { ProdutosStatus } from '@/lib/enums'
import { useCurrentUser } from '@/features/auth/state/auth'
import { useQueryClient } from '@tanstack/react-query'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import HistoricoModificacao from '@/components/form/historico-modificacao'
import ListaBoletos from '@/components/form/boleto/listar-boletos'
import ResumoPrevidenciario from '../previdenciario/resumo-previdenciario'
import ProductDashboard from '../producto-dashboard'
import { Product } from '../../state/selectProduct'
import { useFetchResumeByIdApuracao } from '../../services'
import { useFetchApuracaoByIdProduct } from '../../services/useFetchApuracaoByIdProduct'
import { PageLayout } from '@/layouts'
import { useApuracaoSelecionada } from '../../hooks/seApuracaoSelecionada'
import { WorkflowPanel } from '../previdenciario/processamento/workflow-panel'
import { QuickActionsPanel } from '../previdenciario/processamento/quick-actions-panel'
import { EsocialDashboard } from '../previdenciario/analise/esocial-dashboard'
import ButtonCompetencia from '../previdenciario/button-competencia'
import { useFetchIdPrevidenciario } from '../../services/useFetchIdPrevidenciario'
import { CertificadoUpload } from '../previdenciario/certificado-upload'
import PlanilhasPrevidenciario from '../previdenciario/planilhas-previdenciario'
import ControleDeCredito from '../previdenciario/controle-de-compensacao'

type previdenciarioProps = {
  cnpj?: string
  product: Product
}

export default function Previdenciario({ cnpj, product }: previdenciarioProps) {
  const user = useCurrentUser()
  const queryClient = useQueryClient()

  const { data: apuracoes = [], isLoading } = useFetchApuracaoByIdProduct(product?.id ?? '')

  const { apuracaoSelecionada, setApuracaoSelecionada } = useApuracaoSelecionada()
  const [runtimePrevidenciarioId, setRuntimePrevidenciarioId] = useState<string | null>(null)
  const { data: resumeData } = useFetchResumeByIdApuracao(apuracaoSelecionada?.id)
  const { data: idPrevidenciarioData } = useFetchIdPrevidenciario(apuracaoSelecionada?.id)
  console.log('ID Previdenciário:', idPrevidenciarioData)
  useEffect(() => {
    if (apuracoes.length > 0 && !apuracaoSelecionada) {
      setApuracaoSelecionada(apuracoes[0])
    }
  }, [apuracoes, apuracaoSelecionada, setApuracaoSelecionada])

  useEffect(() => {
    setRuntimePrevidenciarioId(null)
  }, [apuracaoSelecionada?.id])

  const { rubrica, saldo } = useMemo(() => {
    const rubrica = resumeData?.find((r: { typeValue: string }) => r.typeValue === 'RUBRICA')?.value ?? 0
    const saldo = resumeData?.find((r: { typeValue: string }) => r.typeValue === 'SALDO')?.value ?? 0
    return { rubrica, saldo }
  }, [resumeData])

  const idPrevidenciario = useMemo(() => {
    if (runtimePrevidenciarioId) return runtimePrevidenciarioId
    return typeof idPrevidenciarioData?.id === 'string' ? idPrevidenciarioData.id : ''
  }, [runtimePrevidenciarioId, idPrevidenciarioData?.id])

  const idApuracaoCompetencia = useMemo(() => {
    const competencias = apuracaoSelecionada?.competencias
    const competencia = Array.isArray(competencias) ? competencias[0] : competencias
    return competencia?.id_apuracao_competencia ?? ''
  }, [apuracaoSelecionada?.competencias])

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-96 z-50">
        <Loader2 className="h-10 w-10 animate-spin text-primary" />
      </div>
    )
  }
  if (!isLoading && apuracoes.length === 0) {
    return <p>Nenhuma apuração encontrada.</p>
  }
    const isAdmin = user?.typeUser === 'ADMIN'
    const isCEO = user?.typeCargo === 'CEO'
  return (
    <PageLayout title="Previdenciário" showSidebarTrigger={false}>
      <ResumoPrevidenciario rubrica={rubrica} saldo={saldo} />

      <ProductDashboard
        clientInfo={{
          parceiro: product.parceiro,
          empresa: product.empresa,
          nomeAnalista: product.nomeAnalista,
          status: ProdutosStatus[product.status] ?? product.status
        }}
        cnpj={cnpj ?? ''}
        productId={product.id}
        type="PREVIDENCIARIO"
        apuracoes={apuracoes}
        selectedApuracao={apuracaoSelecionada}
      />
      <>
      {isAdmin && (   <ButtonCompetencia id_apuracao={apuracaoSelecionada?.id} />)}
      </>
   
  <Tabs defaultValue="financeiro" className="space-y-4">
    <TabsList className="w-full justify-start overflow-x-auto">
      <TabsTrigger value="financeiro">Financeiro</TabsTrigger>
     {isAdmin && ( <TabsTrigger value="processamento">Processamento</TabsTrigger>)}
    </TabsList>

    <TabsContent value="financeiro" className="space-y-4">
   

      <ControleDeCredito
        cnpj={cnpj ?? ''}
        id_product={product.id}
        onChange={() => {
          queryClient.refetchQueries({ queryKey: ['apuracao', product.id] })
        }}
      />
      <DetalhesDeCredito
        cnpj={cnpj ?? ''}
        id_product={product.id}
        onChange={() => {
          queryClient.refetchQueries({ queryKey: ['apuracao', product.id] })
        }}
      />
       {isAdmin && (
        <>
      <VerbasTable
        idApuracaoCompetencia={idApuracaoCompetencia}
        cnpj={cnpj}
        isEditable={apuracaoSelecionada?.isModifica === true}
        />

      <PlanilhasPrevidenciario
        idApuracaoCompetencia={idApuracaoCompetencia}
        isEditable={apuracaoSelecionada?.isModifica === true}
        />
        </>
      )}
    </TabsContent>
     {isAdmin && (
    <TabsContent value="processamento" className="space-y-4">
      <CertificadoUpload />

      <Tabs defaultValue="workflow" className="space-y-4">
        <TabsList className="w-full justify-start overflow-x-auto">
          <TabsTrigger value="workflow">Workflow</TabsTrigger>
          <TabsTrigger value="analise">Análise</TabsTrigger>
          <TabsTrigger value="acoes_rapidas">Ações Rápidas</TabsTrigger>
        </TabsList>

        <TabsContent value="workflow" className="mt-0">
          <WorkflowPanel
            idPrevidenciario={idPrevidenciario}
            idApuracaoCompetencia={idApuracaoCompetencia}
            onPrevidenciarioCreated={setRuntimePrevidenciarioId}
          />
        </TabsContent>

        <TabsContent value="analise" className="mt-0">
          <EsocialDashboard idPrevidenciario={idPrevidenciario} />
        </TabsContent>

        <TabsContent value="acoes_rapidas" className="mt-0">
          <QuickActionsPanel idPrevidenciario={idPrevidenciario} />
        </TabsContent>
      </Tabs>
    </TabsContent>
      
      )}
  </Tabs>

   
        
           <>
            {isCEO && (
    
          <div className="p-0 flex justify-center items-center">
            <HistoricoModificacao type="PREVIDENCIARIO" productId={product.id} />
          </div> 
         )}
        </>
    

      <ListaBoletos cnpj={cnpj} />
    </PageLayout>
  )
}
